import { Params } from '@angular/router';
import { PageModeEnum } from 'app/teacher/activities/custom/page-mode.enum';
import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const CONTENT_ROUTE = {
  name: 'content',
  route(classId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), this.name];
  },

  VIEW: {
    EMPTY: ':publicunitid//view',
    DEFAULT: `:publicunitid/${PageModeEnum.Default}/view`,
    name: ':publicunitid/:pageMode/view',
    route(classId: string, publicUnitId: string, pageMode = PageModeEnum.Default): string[] {
      return [...TEACHER_ROUTE.CONTENT.route(classId), publicUnitId, pageMode, 'view'];
    },
    queryParams(selectClass = false): Params {
      return {
        selectClass: selectClass 
      };
    }
  },

  EDIT: {
    EMPTY: ':publicunitid//edit',
    DEFAULT: `:publicunitid/${PageModeEnum.Default}/edit`,
    name: ':publicunitid/:pageMode/edit',
    route(classId: string, publicUnitId: string, pageMode = PageModeEnum.Default): string[] {
      return [...TEACHER_ROUTE.CONTENT.route(classId), publicUnitId, pageMode, 'edit'];
    },
  },
};